export function makeOdooContactLink (id: string | number) {
  // @ts-ignore
  let url = import.meta.env.VITE_ODOO_URL;

  return `${url}/web#id=${id}&action=138&model=res.partner&view_type=form&cids=1&menu_id=100`;
}
